import { styled } from 'styled-components'
import { CircleCrossSVG } from '../SVGS/CircleCrossSVG'

export const AppBannerContainer = styled.div`
  height: 60px;

  background-color: ${({ theme }) => theme.colors.siteBackground};
  text-align: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 8px 0 6px;
`

export const AppImage = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`

export const AppText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  text-wrap: wrap;
  color: #333;
`

export const AppLink = styled.a`
  width: 28%;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.brand};
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 24px;
`
export const AppLinkText = styled.p`
  color: white;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const TextAndLogoContainer = styled.div`
  display: flex;

  height: 100%;
  flex-direction: row;
  align-items: center;
`
export const StyledButton = styled.button`
  all: unset;
  cursor: pointer;

  margin-top: 6px;
`

export const ButtonAndLogoAndTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledCircleCrossSVG = styled(CircleCrossSVG)`
  .circle {
    stroke: ${({ theme }) => theme.colors.siteBackground};
    fill: ${({ theme }) => theme.colors.siteBackground};
  }

  .cross {
    fill: ${({ theme }) => theme.colors.brandLight};
  }
`
